import {
  Component,
  OnInit,
  Input,
  HostBinding,
  ElementRef,
  ViewChild,
  HostListener,
  ViewChildren,
} from "@angular/core";
import { IUProperty } from "src/app/shared/interface/umbraco-property";
import { IPictureData } from "../../shared/components/picture/picture.component";
import { ILinkWithColor } from "src/app/shared/interface/link";
import { resolveThemeCssClass } from "../lib/helper/panel-settings";
import { IPanelSettings } from "src/app/shared/interface/panel-settings";
import { applySubtitleSettings, applyTitleSettings } from '../../shared/utils/title-style-settings-utils';
import { ISubtitleStyleSettings, ITitleStyleSettings } from '../../shared/interface/title-style-settings';
import { IRteStyleSettings } from "../../shared/interface/rte-style-settings";
import { applyRteSettings } from '../../shared/utils/rte-style-settings-utils';

interface ICardGridPanelData {
  title: IUProperty<string>;
  subtitle: IUProperty<string>;
  capitalizeTitle?: IUProperty<string[]>;
  items: IUProperty<ICardGridPanelItemData[]>;
  col: IUProperty<string>;
  cardColorPicker?: IUProperty<string>;
  cardFontColorPicker?: IUProperty<string>;
  backgroundImage?: IUProperty<IPictureData>;
  links?: IUProperty<ILinkWithColor[]>;

  panelSettings?: IPanelSettings;
  titleStyleSettingsComposition?: ITitleStyleSettings;
  subtitleStyleSettingsComposition?: ISubtitleStyleSettings;
}

interface ICardGridPanelItemData {
  image: IUProperty<IPictureData>;
  icon: IUProperty<IPictureData>;
  header: IUProperty<string>;
  titleFontWeight: IUProperty<string>;
  titleSize: IUProperty<string>;
  titleColor: IUProperty<string>;
  description: IUProperty<string>;
  backgroundColor: IUProperty<string>;
  cornerRadius: IUProperty<string>;

  rteStyleSettings?: IRteStyleSettings;
}

@Component({
  selector: "app-card-grid-panel",
  templateUrl: "./card-grid-panel.component.html",
  styleUrls: ["./card-grid-panel.component.less"],
})
export class CardGridPanelComponent implements OnInit {
  @Input() data: ICardGridPanelData;
  @HostBinding("class") get hostClasses() {
    return resolveThemeCssClass(this.data.panelSettings);
  }
  @ViewChild("panelElRef", { static: false }) panelElRef: ElementRef<HTMLElement>;
  @ViewChild("titleEl", { static: false }) titleEl: ElementRef<HTMLElement>;
  @ViewChild("subtitleEl", { static: false }) subtitleEl: ElementRef<HTMLElement>;
  @ViewChild("cardEl", { static: false }) cardEl: ElementRef<HTMLElement>;
  @ViewChild("gridEl", { static: false }) gridEl: ElementRef<HTMLElement>;
  @ViewChildren("cardsEl") cardsEl;

  scrollPosition: number = null;

  @HostListener("window:scroll", []) onWindowScroll() {
    this.scrollPosition = window.pageYOffset;
    if (
      this.scrollPosition + window.outerHeight >
      this.panelElRef.nativeElement.offsetTop
    ) {
      this.loadMedia();
    }
  }

  constructor() {}

  ngOnInit() {
    this.scrollPosition = window.pageYOffset;
  }

  ngAfterViewInit(): void {
    this.applyCustomStyling();
    this.applyCardStyles();

    if (
      this.scrollPosition + window.outerHeight >
      this.panelElRef.nativeElement.offsetTop
    ) {
      this.loadMedia();
    }
  }

  loadMedia() {
    if (
      this.data &&
      this.data.backgroundImage &&
      this.data.backgroundImage.value &&
      this.panelElRef &&
      this.panelElRef.nativeElement
    ) {
      this.panelElRef.nativeElement.style.backgroundImage =
        "url(" + this.data.backgroundImage.value.src + ")";
      this.panelElRef.nativeElement.style.backgroundSize = "cover";
      this.panelElRef.nativeElement.style.backgroundRepeat = "no-repeat";
    }
  }

  applyCustomStyling() {
    if (
      this.data &&
      this.data.capitalizeTitle &&
      this.data.capitalizeTitle.value
    ) {
      this.data.capitalizeTitle.value.forEach((item) => {
        switch (item) {
          case "Title":
            if (this.titleEl && this.titleEl.nativeElement)
              this.titleEl.nativeElement.style.textTransform = "uppercase";
            break;
          case "Subtitle":
            if (this.subtitleEl && this.subtitleEl.nativeElement)
              this.subtitleEl.nativeElement.style.textTransform = "uppercase";
            break;
        }
      });
    }
    applyTitleSettings(this.data, this.titleEl);
    applySubtitleSettings(this.data, this.subtitleEl);
  }

  applyCardStyles() {
    if (this.data.items.value && this.cardsEl) {
      this.cardsEl.forEach((item, i) => {
        const currentElem = this.data.items.value[i];

        if (currentElem.titleColor && currentElem.titleColor.value) {
          item.nativeElement.style.setProperty(
            "--item-title-color",
            currentElem.titleColor.value
          );
        } else {
          item.nativeElement.style.setProperty(
            "--item-title-color",
            `#${this.data.cardFontColorPicker.value}`
          );
        }

        if (currentElem.titleFontWeight && currentElem.titleFontWeight.value) {
          item.nativeElement.style.setProperty(
            "--item-title-font-weight",
            currentElem.titleFontWeight.value
          );
        }

        if (currentElem.titleSize && currentElem.titleSize.value) {
          item.nativeElement.style.setProperty(
            "--item-title-size",
            currentElem.titleSize.value + 'px'
          );
        }

        if (currentElem.backgroundColor && currentElem.backgroundColor.value) {
          item.nativeElement.style.setProperty(
            "--item-background-color",
            currentElem.backgroundColor.value
          );
        } else {
          item.nativeElement.style.setProperty(
            "--item-background-color",
            `#${this.data.cardColorPicker.value}`
          );
        }

        if (!currentElem.rteStyleSettings ||
          !currentElem.rteStyleSettings.textColor ||
          !currentElem.rteStyleSettings.textColor.value
        ) {
          item.nativeElement.style.setProperty(
            "--item-description-color",
            `#${this.data.cardFontColorPicker.value}`);
          }

        if (currentElem.cornerRadius && currentElem.cornerRadius.value) {
          item.nativeElement.style.setProperty(
            "--item-corner-radius",
            `${currentElem.cornerRadius.value}px`
          );
        }

        applyRteSettings(currentElem, item);
      });
    }
  }


}
